import DisplayText from '@sdk/components/ui/DisplayText';
import { ThemeColorType } from 'sling-sdk/src/theme/ThemeColorType';
import TranslateWithComponents from '@sdk/lang/TranslateWithComponents';
import gettext from '@sdk/lang/gettext';

import { SearchLabelButton } from './foldableSearch.styles';

export const BroadenSearchLabel = () => {
  return (
    <DisplayText fontSize={11} themeColor={ThemeColorType.iconGray}>
      <TranslateWithComponents
        replaceComponents={{ button: <SearchLabelButton>enter ⏎</SearchLabelButton> }}>
        {gettext('press [[button]] to broaden the search')}
      </TranslateWithComponents>
    </DisplayText>
  );
};
